import { createTheme } from "@mui/material/styles";

const Theme = createTheme({
  palette: {
    primary: {
      main: "#00ab55",
      dark: "#009349",
      text: "#212b36",
    },
    secondary: {
      main: "#ebf8f1",
      text: "#637381",
    },
    error: {
      main: "#E15656",
    },
    text: {
      main: "#212b36",
    },
    background: {
      tableCell: "#74828F",
      default: "#fafffc",
    },
  },
  typography: {
    fontFamily: `"Open Sans", "Helvetica", "Roboto", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

export default Theme;
